<template>
  <section id="about" class="about-wrap style1 pt-100">
    <div class="container">
      <div class="row gx-5 align-items-center">
        <div class="col-lg-6" data-aos="fade-right" data-aos-duration="1200" data-aos-delay="200">
          <div class="about-img-wrap no-padding-top">
            <img class="about-img-one" src="../../assets/images/about/about-img-2.jpg" alt="Pozitiv Medical" />
          </div>
        </div>

        <div class="col-lg-6" data-aos="fade-left" data-aos-duration="1200" data-aos-delay="200">
          <div class="about-content">
            <div class="content-title style1">
              <span class="custom-banner-subtitle">Serviciile noastre</span>
              <h2>Îngrijire medicală completă, într-un singur loc</h2>
              <p>
                Pozitiv Medical este o clinică medicală multidisciplinară care
                oferă servicii dedicate atât sănătății mintale, cât și celei
                fizice. Lucrăm cu grijă, atenție și profesionalism pentru a
                răspunde nevoilor fiecărui pacient.
              </p>
              <p>
                De la evaluare și diagnostic, până la tratament și prevenție,
                specialiștii noștri colaborează pentru a oferi soluții medicale
                personalizate, bazate pe încredere și comunicare.
              </p>
            </div>

            <ul class="content-feature-list list-style style3">
              <li> <a href="/specialitati/cardiologie#specialitati">
                  <span><i class="ri-check-double-line"></i></span>
                  Cardiologie
                </a>
              </li>
              <li>
                <a href="/specialitati/diabet_nutritie_si_boli_metabolice#specialitati">
                  <span><i class="ri-check-double-line"></i></span>
                  Diabet, Nutriție și Boli Metabolice
                </a>
              </li>
              <li>
                <a href="/specialitati/endocrinologie#specialitati">
                  <span><i class="ri-check-double-line"></i></span>
                  Endocrinologie
                </a>
              </li>
              <li>
                <a href="/specialitati/neurologie#specialitati">
                  <span><i class="ri-check-double-line"></i></span>
                  Neurologie
                </a>
              </li>
              <li>
                <a href="/specialitati/psihiatrie#specialitati">
                  <span><i class="ri-check-double-line"></i></span>
                  Psihiatrie
                </a>
              </li>
              <li>
                <a href="/specialitati/psihologie#specialitati">
                  <span><i class="ri-check-double-line"></i></span>
                  Psihologie
                </a>
              </li>
              <li>
                <a href="/specialitati/reumatologie#specialitati">
                  <span><i class="ri-check-double-line"></i></span>
                  Reumatologie
                </a>
              </li>
            </ul>

            <div class="about-subtext">
              <span>
                <img src="../../assets/images/icons/medical-team.svg" alt="Echipa medicală" />
              </span>
              <h5>
                Punem pacientul în centrul fiecărei decizii medicale
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "EasySolution",
};
</script>